import React, { useState, useEffect } from 'react';
import { Helmet } from 'react-helmet';
import { Link, useSearchParams } from 'react-router-dom';
import {
  Box,
  Container,
  Avatar,
  Card,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Button,
  TableFooter,
  TablePagination,
  TextField,
  Divider,
  Checkbox
} from '@material-ui/core';
import PerfectScrollbar from 'react-perfect-scrollbar';
import UserListSkelet from '../../skeletons/UserListSkelet';
import { useDelete, useGet } from '../../API/request';
import { useConfirm } from '../../components/Confirm/index';
import { BallTriangle } from 'react-loader-spinner';
import '../../styles/All.css';

const LanguageList = () => {
  const confirm = useConfirm();
  const getU = useGet();
  const deleteU = useDelete();
  const [searchParams, setSearchParams] = useSearchParams();

  const [isLoaded, setIsLoaded] = useState(true);
  const [isDataLoading, setIsDataLoading] = useState(true);
  const [languages, setLanguages] = useState([]);
  const [page, setPage] = useState(0);
  const [limit, setLimit] = useState(10);
  const [count, setCount] = useState(0);

  const [queryParams, setQueryParams] = useState({
    language: searchParams.get('language') || ''
  });

  const loadLanguages = () => {
    setIsDataLoading(true);
    setIsLoaded(true);

    let endpoint = `languages?page=${page + 1}&limit=${limit}`;

    if (queryParams.language !== '') {
      endpoint += `&language=${searchParams.get('language')}`;
    }

    getU(endpoint)
      .then((resp) => {
        if (resp.status === 'success') {
          setLanguages(resp.data.languages);
          setCount(resp.data.currentCount || 0);
        }
        setIsDataLoading(false);
      })
      .catch((err) => {
        console.log(err.response);
        setUsers([]);
        setCount(0);
        setIsDataLoading(false);
      })
      .finally(() => {
        setIsLoaded(false);
      });
  };

  const handleChangeQueryParams = (event) => {
    setQueryParams({
      ...queryParams,
      [event.target.name]: event.target.value.toUpperCase()
    });
  };

  const handleFilterQueryParams = () => {
    const params = {};
    if (queryParams.language !== '') {
      params.language = queryParams.language;
    }
    if (Object.keys(params).length !== 0) {
      setSearchParams(params);
    }
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeLimit = (event) => {
    setLimit(event.target.value);
    setPage(0);
  };

  const onDelete = (id) => {
    confirm({
      title: 'Удаление',
      content: 'Вы уверены, что хотите удалить язык?',
      onConfirm: () => {
        deleteU(`languages/${id}`)
          .then((resp) => {
            if (resp.status === 'success') {
              loadUsers();
            }
          })
          .catch((e) => {
            // console.log("opened")
            // console.log(e.response)
          });
      }
    });
  };

  useEffect(() => {
    if (queryParams.language === '') {
      searchParams.delete('language');
      setSearchParams(searchParams);
    }
  }, [queryParams]);

  useEffect(() => {
    loadLanguages();
  }, [page, limit, searchParams]);

  if (isLoaded) {
    return (
      <div className="loader">
        <BallTriangle
          height="100"
          width="100"
          color="grey"
          ariaLabel="loading"
        />
      </div>
    );
  }

  return (
    <>
      <Helmet>
        <title>Языки</title>
      </Helmet>
      <Box className="headerWrapper">
        <Box className="headerTitle">Языки</Box>
      </Box>
      <Box
        sx={{ backgroundColor: 'background.default', minHeight: '100%', py: 3 }}
      >
        <Container maxWidth={false}>
          {isDataLoading ? (
            <UserListSkelet />
          ) : (
            <>
              <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
                <Box sx={{ marginLeft: 2 }}>
                  <Link to="/app/language/add">
                    <Button color="primary" variant="contained">
                      Добавить язык
                    </Button>
                  </Link>
                </Box>
              </Box>
              <Box sx={{ pt: 3 }}>
                <Card>
                  <PerfectScrollbar>
                    <Box sx={{ minWidth: 1400 }}>
                      <Box
                        sx={{
                          display: 'flex',
                          mx: 2,
                          mb: 1
                        }}
                      >
                        <TextField
                          fullWidth
                          label="Language"
                          margin="normal"
                          name="language"
                          onChange={handleChangeQueryParams}
                          type="text"
                          value={queryParams.language}
                          variant="outlined"
                          style={{ width: '30%', marginRight: 20 }}
                        />
                        <Button
                          color="primary"
                          variant="contained"
                          onClick={handleFilterQueryParams}
                          sx={{ mt: 2, mb: 1 }}
                        >
                          Применить
                        </Button>
                      </Box>
                      <Table>
                        <TableHead>
                          <TableRow>
                            <TableCell sx={{ width: 80 }}>Id</TableCell>
                            <TableCell>Name</TableCell>
                            <TableCell>Is main</TableCell>
                            <TableCell></TableCell>
                          </TableRow>
                        </TableHead>
                        <TableBody>
                          {languages?.map((language) => (
                            <TableRow hover key={language.id}>
                              <TableCell sx={{ width: 80 }}>
                                {language.id}
                              </TableCell>
                              <TableCell>{language.name || '---'}</TableCell>
                              <TableCell>
                                <Checkbox
                                  size="large"
                                  value={language.isMain}
                                  checked={language.isMain}
                                  disabled={true}
                                  color="default"
                                />
                              </TableCell>
                              <TableCell>
                                <Box sx={{ display: 'flex' }}>
                                  <Box sx={{ display: 'flex' }}>
                                    <Box sx={{ ml: 2 }}>
                                      <Link
                                        to={`/app/language/edit/${language.id}`}
                                        style={
                                          language?.role === 'admin'
                                            ? { pointerEvents: 'none' }
                                            : {}
                                        }
                                      >
                                        <Button
                                          color="primary"
                                          variant="contained"
                                          disabled={language?.role === 'admin'}
                                        >
                                          Редакт.
                                        </Button>
                                      </Link>
                                    </Box>
                                    <Box style={{ marginLeft: '20px' }}>
                                      <Button
                                        color="error"
                                        variant="contained"
                                        onClick={(e) =>
                                          e && onDelete(language.id)
                                        }
                                      >
                                        Удалить
                                      </Button>
                                    </Box>
                                  </Box>
                                </Box>
                              </TableCell>
                            </TableRow>
                          ))}
                        </TableBody>
                        <TableFooter>
                          <TableRow>
                            <TablePagination
                              labelRowsPerPage={
                                <span>Кол-во строк на странице:</span>
                              }
                              rowsPerPageOptions={[10, 20, 30, 40, 50]}
                              colSpan={7}
                              count={count}
                              rowsPerPage={limit}
                              page={page}
                              onPageChange={handleChangePage}
                              onRowsPerPageChange={handleChangeLimit}
                            />
                          </TableRow>
                        </TableFooter>
                      </Table>
                    </Box>
                  </PerfectScrollbar>
                </Card>
              </Box>
            </>
          )}
        </Container>
      </Box>
    </>
  );
};

export default LanguageList;
